import { apiClient } from '@/lib/api/client'

/** Miroir de OrderLineKinds (backend Soly.Sales.Domain) */
export const OrderLineKinds = {
  ProductItem: 'product_item',
  ServiceItem: 'service_item',
  Discount: 'discount',
  Surcharge: 'surcharge',
  Note: 'note',
} as const

export type OrderLineKind = (typeof OrderLineKinds)[keyof typeof OrderLineKinds]

export type DirectSaleOrderDto = {
  salesOrderId: string
  status: 'draft' | 'confirmed'
  isLocked: boolean
  defaultVatPercent: number | null
  lines: DirectSaleOrderLineDto[]
  totalWithoutTax: number
  totalWithTax: number
  vatBreakdown: VatBreakdownDto[]
}

export type DirectSaleOrderLineDto = {
  id: string
  displayOrder: number
  kind: string
  categoryLabel?: string | null
  categoryId?: string | null
  title: string
  description?: string | null
  quantity?: number | null
  unitPriceWithoutTax?: number | null
  discountPercent?: number | null
  vatPercent?: number | null
  lineTotalWithTax?: number | null
}

export type VatBreakdownDto = {
  vatPercent: number
  taxableAmount: number
  taxAmount: number
}

export type UpsertDirectSaleLineRequest = {
  kind?: string
  /** One of the organisation's categories (S07b); the server stores its label. */
  categoryId?: string | null
  /** Free label without id: only kept for lines from before categories belonged to the organisation. */
  categoryLabel?: string | null
  title: string
  description?: string | null
  quantity?: number | null
  unitPriceWithoutTax?: number | null
  vatPercent?: number | null
}

export function getDirectSaleOrder(projectId: string): Promise<DirectSaleOrderDto> {
  return apiClient.get<DirectSaleOrderDto>(`/api/v2/projects/${projectId}/order`)
}

export function addDirectSaleOrderLine(
  projectId: string,
  line: UpsertDirectSaleLineRequest,
): Promise<DirectSaleOrderDto> {
  return apiClient.post<DirectSaleOrderDto>(`/api/v2/projects/${projectId}/order/lines`, line)
}

export function updateDirectSaleOrderLine(
  projectId: string,
  lineId: string,
  line: UpsertDirectSaleLineRequest,
): Promise<DirectSaleOrderDto> {
  return apiClient.put<DirectSaleOrderDto>(
    `/api/v2/projects/${projectId}/order/lines/${lineId}`,
    line,
  )
}

export function deleteDirectSaleOrderLine(
  projectId: string,
  lineId: string,
): Promise<DirectSaleOrderDto> {
  return apiClient.delete<DirectSaleOrderDto>(
    `/api/v2/projects/${projectId}/order/lines/${lineId}`,
  )
}

export function confirmDirectSaleOrder(projectId: string): Promise<DirectSaleOrderDto> {
  return apiClient.post<DirectSaleOrderDto>(`/api/v2/projects/${projectId}/order/confirm`, {})
}
